import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconReadOnly = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeMiterlimit: 1.4,
	clipRule: "evenodd",
	viewBox: "0 0 1024 1024",
	width: "1em",
	height: "1em",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "none",
		d: "M0 0h1024v1024H0z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 72.20680499999999,
		d: "M161.053 346.712C120.092 395.025 89.633 451.302 71.516 512c56.54 189.838 232.375 328.212 440.505 328.212 43.456 0 85.467-6.039 125.29-17.285M259.43 259.407c74.92-49.45 162.793-75.751 252.592-75.62 208.131 0 383.922 138.374 440.462 328.125-30.983 103.672-97.501 193.164-187.869 252.68M259.429 259.407 118.166 118.144M259.43 259.407l159.73 159.73m345.455 345.455 141.263 141.263M764.614 764.592l-159.73-159.73m0 0A131.4 131.4 0 0 0 643.35 512c0-71.988-59.297-131.285-131.329-131.285-34.79 0-68.224 13.872-92.818 38.466M604.84 604.818 419.247 419.225"
	})]
});
export default SvgIconReadOnly;
